import { datasetSliceName } from '@/redux/constants';
import { shallowEqual, useSelector } from 'react-redux';

export const useCurrentFile = () => {
  return useSelector((state) => state[datasetSliceName].currentFile, shallowEqual);
};
